<template>
  <div>
    <v-layout row wrap justify-center align-start>
      <v-flex xs12 md12 lg12>
        <v-card min-height="500px">
          <v-card-text>
            <v-card-actions>
              <ul class="greyDarken1--text px-2">
                <span class="py-0"><b>{{ $t('screener.company.create.currency.note.title') }}</b> :-</span>
                <li v-if="(user_role !== DEFINES.USER_ROLE_SUPER_ADMIN)">{{ $t('subscription.plan.instruction.1') }}</li>
                <li>{{ $t('subscription.plan.instruction.2', { planCount: DEFINES.SUBSCRIPTION_MAX_PLAN_COUNT}) }}</li>
                <li v-if="(DEFINES.SUBSCRIPTION_MAX_PLAN_COUNT == plans.length)">{{ $t('subscription.plan.instruction.3') }}</li>
              </ul>
              <v-spacer></v-spacer>
              <v-btn :disabled="((DEFINES.SUBSCRIPTION_MAX_PLAN_COUNT == plans.length) || (user_role !== DEFINES.USER_ROLE_SUPER_ADMIN))" @click="toggleDialog" small color="success">{{
                $t("subscription.plan.create.new")
              }}</v-btn>
            </v-card-actions>
            <v-data-table :headers="tableHeaders" :items="plans" hide-actions>
              <template v-slot:items="props">
                <td>
                  <span v-if="props.item.metadata">{{props.item.metadata.plan_name}}</span>
                  <span v-else>-</span>
                </td>
                <td>
                  <span v-if="props.item.metadata">{{props.item.metadata.plan_description}}</span>
                  <span v-else>-</span>
                </td>
                <td><span v-if="company">{{getCurrencySymbol()}}</span> {{transformFromSubUnit(props.item.amount)}}</td>
                <td>
                  <span v-if="props.item.active" class="green--text font-weight-bold">{{$t('subscription.plan.table.col.status.active')}}</span>
                  <span v-else color="error" class="red--text font-weight-bold">{{$t('subscription.plan.table.col.status.not.active')}}</span>
                </td>
                <td class="text-uppercase">{{props.item.currency}}</td>
                <td class="text-uppercase">{{props.item.interval}}</td>
                <td>{{timestampToDateTime(props.item.created*1000)}}</td>
                <td>
                  <v-btn :disabled="user_role !== DEFINES.USER_ROLE_SUPER_ADMIN" @click="onEdit(props.item)" small  icon>
                    <v-icon color="primary" small>$vuetify.icons.rms_edit</v-icon>
                  </v-btn>
                </td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent width="70%">
        <v-card>
          <v-toolbar flat>
            <v-toolbar-title>{{
              $t("subscription.plan.create.new.dialog.title")
            }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-icon color="error" @click="onClose"
              >$vuetify.icons.rms_close</v-icon
            >
          </v-toolbar>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="formField.name"
                    outline
                    :label="$t('subscription.plan.form.field.name')"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    v-model="formField.description"
                    outline
                    :label="$t('subscription.plan.form.field.description')"
                    required
                  ></v-textarea>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    v-model="formField.amount"
                    outline
                    :label="$t('subscription.plan.form.field.amount')"
                    :prefix="getCurrencySymbol()"
                    type="number"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    outline
                    disabled
                    :value="company.currency"
                    :label="$t('subscription.plan.form.field.currency')"
                    persistent-hint
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-select
                    v-model="formField.interval"
                    outline
                    :label="$t('subscription.plan.form.field.interval')"
                    required
                    :items="billingIntervals"
                  ></v-select>
                </v-flex>
              </v-layout>
              <p v-if="!formField.id" class="body-1 greyDarken2--text"><b>{{ $t('screener.company.create.currency.note.title') }}</b> :- {{ $t('subscription.plan.instruction.2', { planCount: DEFINES.SUBSCRIPTION_MAX_PLAN_COUNT}) }}</p>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn v-if="!formField.id" outline @click="createPlan()" color="primary" flat @click.native="dialog = false"
              >{{$t('subscription.plan.create.new')}}</v-btn
            >
            <v-btn v-if="formField.id" outline @click="updatePlan()" color="primary" flat @click.native="dialog = false"
              >{{$t('subscription.plan.update.plan')}}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import i18n from "@/i18n";
import DEFINES from "@/defines";
import { getCurrencySymbol } from "@/helper";
import { mapGetters, mapState } from "vuex";

export default {
  name: "SubscriptionPlans",
  props: {
    company: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      tableHeaders: [
        {
          text: i18n.t("subscription.plan.table.header.plan.name"),
          align: "left",
          sortable: false,
          value: "logo",
        },
        {
          text: i18n.t("subscription.plan.table.header.plan.description"),
          align: "left",
          sortable: false,
        },
        {
          text: i18n.t("subscription.plan.table.header.price"),
          align: "left",
          value: "amount"
        },
        {
          text: i18n.t("subscription.plan.table.header.status"),
          align: "left",
          sortable: true,
          value: "title",
        },
        {
          text: i18n.t("subscription.plan.table.header.currency"),
          align: "left",
          sortable: true,
          value: "currency",
        },
        {
          text: i18n.t("subscription.plan.table.header.billing.period"),
          align: "left",
          sortable: true,
          value: "interval",
        },
        {
          text: i18n.t("subscription.plan.table.header.created_at"),
          align: "left",
          sortable: true,
          value: "title",
        },
        {
          text: i18n.t("subscription.plan.table.col.actions"),
          align: "left",
          sortable: false,
        },
      ],
      plans: [],
      dialog: false,
      billingIntervals: [
        {
          text: 'Monthly',
          value: 'month'
        },
        {
          text: 'Yearly',
          value: 'year'
        }
      ],
      formField: {
        name: "",
        description: "",
        amount: null,
        interval: null,
        currency: null,
      },
    };
  },
  computed: {
    ...mapState({
      user_role: (state) => state.user.profile.role,
    }),
  },
  created() {
    this.getPlans();
  },
  methods: {
    async getPlans() {
      await this.$store.dispatch("plan/getPlans").then((response) => {
        this.plans = response.plans;
      });
    },

    async createPlan() {
      this.formField.currency = this.company.currency
      await this.$store
        .dispatch("plan/createPlan", this.formField)
        .then((response) => {
          this.getPlans();
          this.$store.dispatch("app/showMessage", {
            message: this.$t("subscription.plan.created.successfully.msg"),
            color: "success",
          });
          this.onClose()
        })
        .catch((error) => {
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: "error",
          });
        });
    },

    async updatePlan() {
      this.formField.currency = this.company.currency
      await this.$store
        .dispatch("plan/updatePlan", this.formField)
        .then((response) => {
          this.getPlans();
          this.$store.dispatch("app/showMessage", {
            message: this.$t("subscription.plan.created.successfully.msg"),
            color: "success",
          });
          this.onClose()
        })
        .catch((error) => {
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: "error",
          });
        });
    },

    getCurrencySymbol() {
      return getCurrencySymbol(this.company.currency);
    },

    toggleDialog(){
      this.dialog = !this.dialog
    },

    timestampToDateTime(timestamp) {
      let date = new Date(timestamp)
      return date.toDateString()
    },

    transformFromSubUnit(amount){
      return (amount / 100).toFixed(2);
    },

    resetFormFields() {
      return this.formField = {
        name: "",
        description: "",
        amount: null,
        interval: null,
        currency: null,
      }
    },

    onEdit(plan) {
      this.formField.name = plan.metadata.plan_name
      this.formField.description = plan.metadata.plan_description
      this.formField.amount = this.transformFromSubUnit(plan.amount)
      this.formField.interval = plan.interval
      this.formField.currency = this.company.currency
      this.formField.id = plan.id

      this.dialog = true
    },

    onClose() {
      this.resetFormFields()
      this.dialog = false
    }
  },
};
</script>
